import { SportDataGatewayQueryInfo, EventPushResponse, OnNext, EventsBySportIdRequest } from "sb-resp-lib";
import { EventsFromTopLeaguesBySportIdRequest, MarketTypeRequest } from "sbtech-online-sportcontent-sportbook";
import { TimeRange } from "sbtech-sports-data-api-client";
import { EventListPresenterRequest } from "../../contracts";

/*tslint:disable:no-non-null-assertion */
export const queryBuilder = {
    eventStateMap: {
        [EventsBySportIdRequest.EventStateEnum.Live]: "isLive eq true",
        [EventsBySportIdRequest.EventStateEnum.PreLive]: "isLive eq false",
        [EventsBySportIdRequest.EventStateEnum.Mixed]: ""
    },

    buildQueryTopLeagues(queryParams: QueryParams): SportDataGatewayQueryInfo<EventPushResponse> {
        const filters = [
            this.buildLiveFilter(queryParams.request),
            this.buildEventType(queryParams.request),
            this.buildSportsFilter(queryParams),
            this.buildEventTagsFilter(queryParams.request)
        ].filter(x => x !== "");

        let queryInfo = new SportDataGatewayQueryInfo(`$filter=${filters.join(" and ")}`, queryParams.messageHandler);
        queryInfo.includeMarkets = this.buildMarketsQuery(queryParams);
        this.buildDateRangeFilter(queryParams.request, queryInfo);

        return queryInfo;
    },

    buildLiveFilter(request: EventsFromTopLeaguesBySportIdRequest): string {
        return this.eventStateMap[request.eventState || EventsBySportIdRequest.EventStateEnum.Mixed];
    },

    buildEventType(request: EventsFromTopLeaguesBySportIdRequest): string {
        return (request.eventTypes && request.eventTypes.length && `type in (${request.eventTypes.map(type => `'${type}'`).join(",")})`) || "";
    },

    buildSportsFilter(queryParams: QueryParams): string {
        const sportIds = queryParams.request.ids;
        return sportIds.length ? `sportId in (${sportIds.map(x => `'${x}'`).join(",")})` : "";
    },

    buildEventTagsFilter(request: EventsFromTopLeaguesBySportIdRequest): string {
        return request.eventTags && request.eventTags.length
            ? `Tags/any(tag: tag in (${request.eventTags.map(tag => `'${tag}'`).join(",")}))` : "";
    },

    buildMarketsQuery(queryParams: QueryParams): string {
        const marketsQueries: string[] = [];

        queryParams.request.marketTypeRequests.forEach(marketTypeRequest => {
            const marketTypes = `marketType/id in (${marketTypeRequest.marketTypeIds.map(m => `'${m}'`).join(",")})`;

            if (marketTypeRequest.sportIds.length) {
                const sportIds = `sportId in (${marketTypeRequest.sportIds.map(id => `'${id}'`).join(",")})`;
                marketsQueries.push(
                    marketTypeRequest.statement === MarketTypeRequest.StatementEnum.Include
                        ? `(${marketTypes} and ${sportIds})`
                        : `(${marketTypes} and not(${sportIds}))`
                );
            } else {
                marketsQueries.push(`(${marketTypes})`);
            }
        });

        return `$filter=${marketsQueries.join(" or ")}`;
    },

    buildDateRangeFilter(request: EventsFromTopLeaguesBySportIdRequest, queryInfo: SportDataGatewayQueryInfo<EventPushResponse>) {
        if (request.dateRange) {
            queryInfo.from = request.dateRange.from!.toISOString();
            queryInfo.timeRange = TimeRange[request.dateRange.timeRange!];
        }
    },

    buildQueryByEventIds(queryParams: QueryParams): SportDataGatewayQueryInfo<EventPushResponse> {
        const filter = this.buildEventIdsFilter(queryParams.request.ids);

        let queryInfo = new SportDataGatewayQueryInfo(`$filter=${filter}`, queryParams.messageHandler);
        queryInfo.includeMarkets = this.buildMarketsQuery(queryParams);
        return queryInfo;
    },

    buildEventIdsFilter(eventIds: string[]): string {
        return `id in (${eventIds.map(id => `'${id}'`).join(",")})`;
    },

    buildQueryByLeagueIds(queryParams: QueryParams): SportDataGatewayQueryInfo<EventPushResponse> {
        const filter = this.buildLeagueIdsFilter(queryParams.request.ids);

        let queryInfo = new SportDataGatewayQueryInfo(`$filter=${filter}`, queryParams.messageHandler);
        queryInfo.includeMarkets = this.buildMarketsQuery(queryParams);
        return queryInfo;
    },

    buildLeagueIdsFilter(leagueIds: string[]): string {
        return `leagueId in (${leagueIds.map(id => `'${id}'`).join(",")})`;
    }
}

export type QueryParams = {
    request: EventListPresenterRequest,
    messageHandler: OnNext<EventPushResponse>
}